module.exports = __webpack_public_path__ + "img/GrE_GreekTechPriestRange1_ua.58ae91d1.webp";